import React from "react";
import GoogleMapReact from 'google-map-react';
import "../../styles/components/googleMap.css";
import MarkerPin from "./MarkerPin";
import { getDistance } from '../../Utils/DistanceCalculator';

export default function SimpleMap(props) {
    const defaultProps = {
        center: {
            lat: props?.lat,
            lng: props?.lng
        },
        zoom: 17,
    };

    return (
        <div style={{ height: props?.height, width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_GCP_KEY }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                options={{ scrollwheel: true, zoomControl: false, }}
            >
                {!props?.denied && <MarkerPin
                    defaultMarker={true}
                    lat={props?.lat}
                    lng={props?.lng}
                    src={null}
                />}
                {props.stores?.map((store, index) => {
                    return <MarkerPin
                        defaultMarker={false}
                        lat={store?.latitude}
                        lng={store?.longitude}
                        redirectTo={`${store?.latitude},${store?.longitude}`}
                        src={"null"}
                        distance={getDistance(props?.lat, props?.lng, store?.latitude, store?.longitude)}
                        data={[store]}
                    />
                })}
            </GoogleMapReact>
        </div>
    );
}